var _defs, _g, _g2, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5491",
    "data-name": "Group 5491",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.769,
    height: 82.769,
    viewBox: "0 0 82.769 82.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 0.063,
    x2: 0.979,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d37c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903163"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_9532",
    "data-name": "Path 9532",
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.385,0A41.385,41.385,0,1,1,0,41.385,41.385,41.385,0,0,1,41.385,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.38470458984375 0.9999923706054688 C 35.9323616027832 0.9999923706054688 30.64365005493164 2.067619323730469 25.66545867919922 4.1732177734375 C 20.85659408569336 6.207191467285156 16.53758239746094 9.119216918945312 12.82840728759766 12.82840728759766 C 9.119216918945312 16.53758239746094 6.207191467285156 20.85659408569336 4.1732177734375 25.66545867919922 C 2.067619323730469 30.64365005493164 0.9999923706054688 35.9323616027832 0.9999923706054688 41.38470458984375 C 0.9999923706054688 46.8370475769043 2.067619323730469 52.12576293945312 4.1732177734375 57.10395050048828 C 6.207191467285156 61.91280364990234 9.119216918945312 66.2318115234375 12.82840728759766 69.94100189208984 C 16.53758239746094 73.65018463134766 20.85659408569336 76.56220245361328 25.66545867919922 78.59618377685547 C 30.64365005493164 80.7017822265625 35.9323616027832 81.76940155029297 41.38470458984375 81.76940155029297 C 46.8370475769043 81.76940155029297 52.12576293945312 80.7017822265625 57.10395050048828 78.59618377685547 C 61.91281509399414 76.56220245361328 66.2318115234375 73.65018463134766 69.94100189208984 69.94100189208984 C 73.65018463134766 66.2318115234375 76.56220245361328 61.91281509399414 78.59618377685547 57.10395050048828 C 80.7017822265625 52.12576293945312 81.76940155029297 46.8370475769043 81.76940155029297 41.38470458984375 C 81.76940155029297 35.9323616027832 80.7017822265625 30.64365005493164 78.59618377685547 25.66545867919922 C 76.56220245361328 20.85659408569336 73.65018463134766 16.53758239746094 69.94100189208984 12.82840728759766 C 66.2318115234375 9.119216918945312 61.91280364990234 6.207191467285156 57.10395050048828 4.1732177734375 C 52.12576293945312 2.067619323730469 46.8370475769043 0.9999923706054688 41.38470458984375 0.9999923706054688 M 41.38470458984375 -7.62939453125e-06 C 64.2408447265625 -7.62939453125e-06 82.76940155029297 18.52855682373047 82.76940155029297 41.38470458984375 C 82.76940155029297 64.2408447265625 64.2408447265625 82.76940155029297 41.38470458984375 82.76940155029297 C 18.52855682373047 82.76940155029297 -7.62939453125e-06 64.2408447265625 -7.62939453125e-06 41.38470458984375 C -7.62939453125e-06 18.52855682373047 18.52855682373047 -7.62939453125e-06 41.38470458984375 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#f26c21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(7 7)",
    fill: "none",
    stroke: "#f26c21",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 34,
    rx: 34.5,
    ry: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 34,
    rx: 34,
    ry: 33.5,
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(15 14)",
    fill: "url(#linear-gradient)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(34 55)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.f670de4c638855cf294dd36ac906f8bf.svg";
export { ForwardRef as ReactComponent };